import * as React from "react";
import { BaseComponent } from "./BaseComponent";
import * as Dati from "../Dati";
import { Trad } from "../components/";

interface ICampoCheckBoxProps extends Dati.IBaseProps {
    Valore: boolean;
    Etichetta: string;
}

export class CampoCheckBox extends BaseComponent<ICampoCheckBoxProps, {}> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        return (
            <label className={this.props.CSS == undefined ? "kt-checkbox kt-checkbox--brand" : this.props.CSS}>
                {Trad.Trad(this.props.Etichetta)}
                <input name={this.props.Name} id={this.props.Id} type="checkbox" checked={this.props.Valore} onChange={e => this.props.OnChange(e, e.currentTarget.checked)} />
                <span></span>
            </label>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CampoCheckBox.tsx